export default __webpack_public_path__ + "static/media/moreAccessoriesActive.88dca024.svg";